import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function Card({
  children = null,
  cardTitle = '',
  isSecondary = false,
}) {
  const { whiteLabelSettings: { primaryColour, secondaryColour } = {} } =
    useWhiteLabelSettings();

  const backgroundStyle = isSecondary
    ? { backgroundColor: secondaryColour || DEFAULT_PRIMARY_COLOUR }
    : { backgroundColor: primaryColour || DEFAULT_PRIMARY_COLOUR };

  return (
    <>
      <div
        style={backgroundStyle}
        className="mt-[40px] rounded-t-[10px] text-white text-[24px] font-medium"
      >
        <div className="p-4">
          <div>{cardTitle}</div>
        </div>
      </div>
      <div className="rounded-b-lg mb-7 bg-white">
        <div className="mx-4 md:mx-8 lg:mt-0">{children}</div>
      </div>
    </>
  );
}
